import React, { useState } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  IconButton
} from '@material-ui/core';
import { DeleteRounded, AddCircle } from '@material-ui/icons';
import InlineTable from '@/module/common/component/InlineTable';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import AutocompleteModal from '@/module/common/component/AutocompleteModal';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import { locationColumn } from '../constants';
import { TableWrapped } from '@/module/company/component/CompanyPaper/styled';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';

const LocationsInformation = ({ formValue, setFormValue, disabled }) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const { locations: listLocations } = useSelector(state => state.globalState);

  useEffect(() => {
    if (!isEmpty(formValue.restrictedLocationIds)) {
      const newSelectedList = listLocations.filter(location => {
        return formValue.restrictedLocationIds.some(test => {
          return test === location.id;
        });
      });
      setSelectedList(newSelectedList);
    }
  }, [formValue]);

  const onCloseModal = () => {
    setShowModal(false);
  };
  const onAddNewTest = data => {
    const newSelectedList = selectedList.concat(data);
    const restrictedLocationIds = newSelectedList.map(item => item.id);

    setSelectedList(newSelectedList);
    setFormValue({ ...formValue, restrictedLocationIds });
    setShowModal(false);
  };

  const onDeleteTest = index => {
    let newSelectedList = [...selectedList];
    newSelectedList.splice(index, 1);
    const restrictedLocationIds = newSelectedList.map(item => item.id);

    setSelectedList(newSelectedList);
    setFormValue({ ...formValue, restrictedLocationIds });
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows
      }}
      {...props}
    />
  );
  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {locationColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
            />
          ) : (
            <TableCell key={item.stateValue}></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const TableFooter = () =>
    disabled ? null : (
      <StyledButtonEnhance
        background="#EFDFEB"
        color="#AD5E99"
        backgroundHover="#EFDFEB"
        onClick={() => setShowModal(true)}
      >
        <div className="add-group">
          <span>Add restricted location</span>
          <AddCircle />
        </div>
      </StyledButtonEnhance>
    );

  const renderRow = onDeleteTest => (row, i, onDeleteValue) => (
    <>
      <TableCell>{!hiddenRows.name && row.name}</TableCell>
      <TableCell>{!hiddenRows.address && row.address}</TableCell>
      <TableCell align="right">
        {!disabled && (
          <IconButton
            className="delete-icon"
            onClick={() => (onDeleteTest ? onDeleteTest(i) : onDeleteValue(i))}
          >
            <DeleteRounded />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  return (
    <TableWrapped>
      <InlineTable
        Header={TableHeader}
        data={selectedList}
        Footer={TableFooter}
        noDataHelperText={
          disabled
            ? 'No data'
            : 'Click button "Add restricted location" to create new one'
        }
        renderRow={renderRow(onDeleteTest)}
      />
      <Dialog maxWidth="lg" open={showModal} onClose={onCloseModal}>
        <AutocompleteModal
          onClose={onCloseModal}
          title="Locations"
          optionLabel="name"
          textFieldPlaceholder="Select location"
          onSubmit={onAddNewTest}
          Header={TableHeader}
          renderRow={renderRow()}
          options={listLocations || []}
          existedOption={selectedList}
        />
      </Dialog>
    </TableWrapped>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  display: flex;
  justify-content: center;
  max-width: 220px;
  float: right;
  margin-top: 15px;
  height: 35px;
  padding: 8px 16px;
  align-items: center;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
    }
  }
`;

export default LocationsInformation;
